export const GET_CLUBS_DETAILS_REQUEST = "GET_CLUBS_DETAILS_REQUEST";
export const GET_CLUBS_DETAILS_SUCCESS = "GET_CLUBS_DETAILS_SUCCESS";
export const GET_CLUBS_DETAILS_FAIL = "GET_CLUBS_DETAILS_FAIL";